import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import { BrowserRouter } from 'react-router-dom'

// Keep css in order :)
import registerServiceWorker from './registerServiceWorker';
import {Provider} from "react-redux";
import store from "./redux/store";
import {initialState} from "./redux/reducers";
import './css/layout.css';

import {connectLocalStorage, subscribeLocalStorage} from "./scripts/connectLocalStorage";

connectLocalStorage.then((localStorage) => {
    const appStorage = store({
        ...initialState,
        ...localStorage,
    });
    appStorage.subscribe(subscribeLocalStorage(appStorage));
    ReactDOM.render(
        <Provider store={appStorage}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Provider>
    , document.getElementById('root'));
});

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js